export default __webpack_public_path__ + "static/media/add-leader-icon.c8637851.svg";